import { TestId } from "@/constants/globals"
import {
   ERROR_MESSAGES,
   VALIDATION_PATTERNS,
} from "@/pages/Settings/Users/constants"
import { UserFormData } from "@/pages/Settings/Users/types"
import { UserRole } from "@/types/user"

export type UserFormField = keyof UserFormData

export interface FormFieldConfig {
   placeholder: string
   validate: (value: string) => boolean
   errorMessage?: string
   testId?: string
   helperTextTestId?: string
}

export const initialUserFormData: UserFormData = {
   firstName: "",
   lastName: "",
   email: "",
   phoneNumber: "",
   role: "" as UserRole,
}

export const levelSettingFieldConfig: Record<string, FormFieldConfig> = {
   name: {
      placeholder: "Name",
      validate: (value) =>
         VALIDATION_PATTERNS.NAME.test(value) && value.length > 0,
      errorMessage: ERROR_MESSAGES.NAME,
   },
   iconName: {
      placeholder: "Icon Name",
      validate: (value) =>
         VALIDATION_PATTERNS.NAME.test(value) && value.length > 0,
      errorMessage: ERROR_MESSAGES.NAME,
   },
}

export const alertFieldConfig: Record<string, FormFieldConfig> = {
   name: {
      placeholder: "Name",
      validate: (value) =>
         VALIDATION_PATTERNS.NAME.test(value) && value.length > 0,
      errorMessage: ERROR_MESSAGES.NAME,
   },
}

export const userFieldConfig: Record<UserFormField, FormFieldConfig> = {
   firstName: {
      placeholder: "Name",
      validate: (value) =>
         VALIDATION_PATTERNS.NAME.test(value) && value.length > 0,
      errorMessage: ERROR_MESSAGES.NAME,
      testId: TestId.USER_FORM_NAME_INPUT,
   },
   lastName: {
      placeholder: "Surname",
      validate: (value) =>
         VALIDATION_PATTERNS.NAME.test(value) && value.length > 0,
      errorMessage: ERROR_MESSAGES.NAME,
      testId: TestId.USER_FORM_LAST_NAME_INPUT,
   },
   email: {
      placeholder: "Email address",
      validate: (value) => VALIDATION_PATTERNS.EMAIL.test(value),
      errorMessage: ERROR_MESSAGES.EMAIL,
      testId: TestId.USER_FORM_EMAIL_INPUT,
      helperTextTestId: TestId.USER_FORM_EMAIL_HELPER_TEXT,
   },
   phoneNumber: {
      placeholder: "Phone number",
      validate: (value) =>
         VALIDATION_PATTERNS.PHONE.test(value) &&
         value.length >= 9 &&
         value.length <= 15,
      errorMessage: ERROR_MESSAGES.PHONE,
      testId: TestId.USER_FORM_PHONE_NUMBER_INPUT,
   },
   role: {
      placeholder: "Role",
      validate: (value) => value.length > 0,
   },
}
